import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';

import { LoadingDataSpinner } from '../LoadingDataSpinner';
import { Domain } from '../types/Domain';
import { UserDefinedPoolModel } from '../types/PoolModel';
import { AddNewPoolButton } from './AddNewPoolButton';
import { DataConnectMultiPoolTableBody } from './DataConnectMultiPoolTableBody';
import { DataConnectMultiPoolTableHeaders } from './DataConnectMultiPoolTableHeaders';


export type DataConnectMultiPoolSectionProps = Readonly<{
  pools: Record<string, UserDefinedPoolModel>;
  bridgeDomains: Record<string, Domain>;
  siteId: string;
  refreshPoolsAndClusters: () => void;
  hasLoadedPoolsAndClusters: boolean;
}>

export function DataConnectMultiPoolSection(props: DataConnectMultiPoolSectionProps) {
  const existingPoolNames = Object.values(props.pools).map((pool: UserDefinedPoolModel) => pool.displayName);

  return (
    <div className={sectionExtraPaddingBottom}>
      <AddNewPoolButton
        existingPoolNames={existingPoolNames}
        siteId={props.siteId}
        refreshEdgePools={props.refreshPoolsAndClusters}
        hasLoadedEdgePools={props.hasLoadedPoolsAndClusters}
      />
      {!props.hasLoadedPoolsAndClusters && <>
        {LoadingDataSpinner()}
      </>}
      {(props.hasLoadedPoolsAndClusters && _.isEmpty(props.pools)) && <>
          <div className={'tb-data-grid-cell-text tb-data-grid-DataConnect-center'}>
            <span>{Messages.dataConnectSiteSettingsPoolNotFoundWarning()}</span>
          </div>
      </>}
      {!_.isEmpty(props.pools) && <>
        <table className={`${multiPoolTableStyle} tb-static-grid-table-cluster-pool-width`}>
          <DataConnectMultiPoolTableHeaders />
          <DataConnectMultiPoolTableBody
            pools={props.pools}
            bridgeDomains={props.bridgeDomains}
            existingPoolNames={existingPoolNames}
            siteId={props.siteId}
            refreshPoolsAndClusters={props.refreshPoolsAndClusters}
          />
        </table>
      </>}

    </div>
  );
}

export const sectionExtraPaddingBottom = style({
  paddingBottom: TabStyles.Spacing.MediumSpace
});

const multiPoolTableStyle = style({
  borderSpacing: 0,
  textAlign: 'left',
  backgroundColor: TabStyles.Colors.White,
  cursor: 'default',
  paddingTop: 10
});
